module.exports = __webpack_public_path__ + "media/images/flags/32/Bhutan-cf55921198072d88e83bcec63dde1816.png";